import {AfterViewInit, Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {FinanceService} from '../../../services/api/finance.service';
import {FinanceProfileModel, FinanceWalletModel} from '../../../models/finance.model';
import {PaymentTransactionModel} from '../../../models/contract.model';
import {AlertService} from '../../../services/notify/alert.service';
import {ModalService} from '../../../services/modal/modal.service';
import {TranslateService} from '@ngx-translate/core';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-barter',
    templateUrl: './barter.component.html',
    styleUrls: ['./barter.component.scss'],
})
export class BarterComponent implements OnInit, AfterViewInit {
    @ViewChild('barterView') public barterView;
    @Input() public purse: FinanceProfileModel;
    @Input() public masterWallet: FinanceWalletModel|undefined;
    @Input() public isMaster: boolean;
    @Input() public outWallet: FinanceWalletModel;
    @Output() public emitFinish: EventEmitter<boolean> = new EventEmitter<boolean>();
    public wallets: FinanceWalletModel[] = [];
    isLockButton = false;

    loading = true;

    constructor(
        protected financeService: FinanceService,
        protected alert: AlertService,
        protected modalService: ModalService,
        protected translate: TranslateService
    ) {
    }

    ngOnInit(): void {
        if (!this.purse) {
            if (this.outWallet.owner_type === 'MEMBER') {
                this.financeService.getAllPrivateWallets().subscribe(res => {
                    this.purse = {wallets: res.wallets};
                    this.wallets = res.wallets.filter((x: FinanceWalletModel) => x.guid !== this.outWallet.guid);
                    this.wallets = this.wallets.sort((n1, n2) => {
                        const arg1 = n1.title;
                        const arg2 = n2.title;
                        if (arg1 > arg2) {
                            return 1;
                        } else {
                            return -1;
                        }
                    });
                    this.masterWallet = res.wallets.find((x: FinanceWalletModel) => x.is_master);
                    this.loading = false;
                });
            } else {
                this.financeService.getFinance().subscribe((res: { purse: FinanceProfileModel }) => {
                    this.purse = res.purse;
                    this.wallets = res.purse.wallets.filter((x: FinanceWalletModel) => x.guid !== this.outWallet.guid);
                    this.wallets = this.wallets.sort((n1, n2) => {
                        const arg1 = n1.title;
                        const arg2 = n2.title;
                        if (arg1 > arg2) {
                            return 1;
                        } else {
                            return -1;
                        }
                    });
                    this.masterWallet = res.purse.wallets.find((x: FinanceWalletModel) => x.is_master);
                    this.loading = false;
                });
            }
        } else {
            this.wallets = this.purse.wallets.filter((x: FinanceWalletModel) => x.guid !== this.outWallet.guid);
            this.wallets = this.wallets.sort((n1, n2) => {
                const arg1 = n1.title;
                const arg2 = n2.title;
                if (arg1 > arg2) {
                    return 1;
                } else {
                    return -1;
                }
            });
            this.masterWallet? null : this.masterWallet = this.purse.wallets.filter((x: FinanceWalletModel) => x.is_master)[0];
            this.loading = false;
        }

        const sub = this.modalService.emitOnClose.subscribe(() => {
            this.emitFinish.emit();
            sub.unsubscribe();
        });
    }

    ngAfterViewInit(): void {
        this.modalService.openTemplateModal(this.barterView);
    }

    onBarterEvent($wallet, $total, modal: NgbModalRef|null = null): void {
        if (!$total.value) {
            return this.alert.setAlert(this.translate.instant('ALERTS.SET_TOTAL'), 'blue');
        }
        if ($wallet) {
            const wallet: FinanceWalletModel = this.purse.wallets.filter(w => w.guid === $wallet.value)[0];
            if (!wallet || !wallet.active) {
                return this.alert.setAlert(this.translate.instant('ALERTS.NOT_ACTIVE_WALLET'), 'blue');
            }
        }
        this.isLockButton = true;
        if (this.isMaster) {
            this.createBarter(this.outWallet.guid, $wallet.value, $total.value, modal);
        } else {
            this.createBarter(this.masterWallet?.guid, this.outWallet.guid, $total.value, modal);
        }
    }

    createBarter(outWallet, innerWallet, total, modal): void {
        this.financeService.createBarterTransaction(outWallet, innerWallet, this.outWallet.owner_type, total)
            .subscribe({
                next: (res: { transaction: PaymentTransactionModel }) => {
                    this.alert.setAlert(this.translate.instant('ALERTS.NEW_TRANSACTION',
                        {guid: res.transaction.guid, total: res.transaction.total}), 'green');
                    this.emitFinish.emit(true);
                    modal.close();
                    setTimeout(() => {
                        this.isLockButton = false;
                    }, 500);
                }, error: error => {
                    this.alert.setAlert(error.message, 'blue');
                    this.isLockButton = false;
                },
            });
    }
}
